import { render } from "./Tag_management.vue?vue&type=template&id=424a4418&scoped=true"
import script from "./Tag_management.vue?vue&type=script&lang=js"
export * from "./Tag_management.vue?vue&type=script&lang=js"

import "./Tag_management.vue?vue&type=style&index=0&id=424a4418&scoped=true&lang=scss"
import "./Tag_management.vue?vue&type=style&index=1&id=424a4418&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424a4418"]])

export default __exports__